import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { isReturnRateSourceSelectionEnabled } from "@redotech/redo-return-core-common/shipping/return-rate-source-selection";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

export function getReturnRateSourceCarrierAccountsQueryKey(teamId?: string) {
  return ["returnRateSourceCarrierAccounts", teamId ?? null] as const;
}

export function useReturnRateSourceCarrierAccounts() {
  const team = useContext(TeamContext);
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  const teamId = team?._id?.toString();
  const rateSourceSelectionPending = !team;
  const rateSourceSelectionEnabled = team
    ? isReturnRateSourceSelectionEnabled(team)
    : false;

  const query = useQuery({
    queryKey: getReturnRateSourceCarrierAccountsQueryKey(teamId),
    queryFn: async ({ signal }) => {
      return await rpcClient.getCarrierAccounts(null, { signal });
    },
    enabled: rateSourceSelectionEnabled && !!teamId,
  });

  return { ...query, rateSourceSelectionEnabled, rateSourceSelectionPending };
}
